import type { FaireProductEntity } from "../../entity_types/product";

export const p_3y2n8w8zp6: FaireProductEntity = {
  token: "p_3y2n8w8zp6",
  type: "product",
  name: 'Herringbone Tote-13x16"L',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/8aeadc3c9e9ec096a2109b1c4db9cfc1077c51fe634d1e08ff656e4469d6046b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7bf05e9532553534427d5bf5e2f45651b11f2e2fa53de52697ad4d0a1e8a2de2.jpeg",
    "https://cdn.faire.com/fastly/768462e91b4e5dfe9d5db71354a8d4ce21054d971b6e13a422477cd28d6598af.jpeg",
    "https://cdn.faire.com/fastly/9a6aab938684b4c617d8e0fff9ed46950b3f7cd133491d1a920da926ac1d353d.jpeg",
    "https://cdn.faire.com/fastly/8110a47ce7c38f74d1088b1c1ae99522e1bbba3d0a939a2f49e9bc8970732644.jpeg",
    "https://cdn.faire.com/fastly/092c723ea763d1fb66247a0da3a412c29b96b29a2fb89af608935e59afe48a5a.jpeg",
    "https://cdn.faire.com/fastly/39e2fce5a1aae23d7da30407c79f9222cfc92b6a7c2de7d98c5006bb92bb44a5.jpeg",
  ],
  priceDollars: 8.5,
  description:
    "This Herringbone Tote combines natural texture with a classic design. The durable jute material is intricately woven in a herringbone pattern, offering both strength and style. Spacious and eco-friendly, it’s perfect for carrying essentials while adding a rustic, earthy charm to casual outings.",
  tags: [],
  msrpDollars: 17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:06.401Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
